/** @param {string} lazyComponentPath */
export function importLazyComponent(lazyComponentPath) {
    // the below call forces webpack to create separate chunks for each file
    // in the current directory that matches the pattern [fileName].lazy.[ext]
    return import(`./${lazyComponentPath}.lazy`);
}
